import React from 'react';
import PhotoRow from './PhotoRow.js';
import Presenter from '../../presenter.js';
import RequestProperties from '../object.request.props.js';
import { toast } from 'react-toastify';
import windowStop from 'utils/windowStop.js'

export default class PhotoList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      rawData           : [],
      isLoading         : true,
      isLoadingLoadmore : false,
      total             : 0,
      nextPage          : null,
    }

    this.onReadSuccess   = this.onReadSuccess.bind(this)
    this.onReadFailed    = this.onReadFailed.bind(this)
    
    this.onDelete        = this.onDelete.bind(this)
    this.onDeleteSuccess = this.onDeleteSuccess.bind(this)
    this.onDeleteFailed  = this.onDeleteFailed.bind(this)
  }

  generateRow(row) {
    var element = row.map((val, index) => {
      return (
        <PhotoRow 
          self={this} 
          RowData={val} 
          key={val.Alias}
          UserReducer={this.props.UserReducer}
          toogleDeleteImageModal={this.props.toogleDeleteImageModal} 
          onDelete = {this.onDelete}
        />
      )
    })
    return element;
  }

  onDelete(alias) {
    let confirm = window.confirm("Delete this photo?")
    if(confirm) {
      Presenter.DeletePhoto(RequestProperties.Delete(
        this.onDeleteSuccess,
        this.onDeleteFailed,
        alias,
        this.props.UserReducer.token
      )) 
    }
  }

  onDeleteSuccess(params, response) {
    const {rawData} = this.state
    let response_alias = response.data.Alias

    for(let i = 0; i < rawData.length; i++) {
      if(rawData[i].Alias === response_alias) {
        rawData.splice(i, 1)
      }
    }
    this.setState({rawData: rawData})


    toast.success("Photo deleted")
  }

  onDeleteFailed(response) {
    console.log('Delete failed');
  }

  onRead(alias) {
    Presenter.ReadPhoto(
      RequestProperties.Read(
        "Read", 
        this.onReadSuccess, 
        this.onReadFailed, 
        'ChekinTime',
        alias,
        this.props.UserReducer.token
      )
    )
  }

  onReadSuccess(params, response) {
    this.setState({
      isLoading         : false,
      isLoadingLoadmore : false,
      total             : response.data.count,
      nextPage          : response.data.next,
      rawData           : response.data.results,
    })
  }

  onReadFailed(response) {
    console.log('Read Failed');
  }

  componentWillReceiveProps(nextProps) {
    const {alias} = this.props

    if(nextProps.readImageAfterUpload) {
      this.onRead(alias)
    }
  }

  componentDidMount() {
    const {alias} = this.props
    this.onRead(alias)
  }

  componentWillUnmount() {
    windowStop()
  }

  renderPhoto() {
    const {isLoading, rawData} = this.state 
    if(isLoading) {
      return (
        <div className="card-block align-center NoDataContainer">
          <div>
            <div className="loading_box"></div>
            <br />
            <span className="NoDataLabel"><b>Loading...</b></span>
          </div>
        </div>
      )
    } else {
      if(rawData.length === 0) {
        return (
          <div className="col-md-12 text-center">
            <div className="card-block align-center NoDataContainer">
              <div>
                <span><i className="fa-5x icon-notebook"></i></span><br/>
                <span><b>No Images Found</b></span><br/>
              </div>
            </div>
          </div>
        )
      } else {
        return (
          this.generateRow(rawData)
        )
      }
    }
  }

  render() {
    return (
      <div className="col-md-7">
        <div className="card-block white-background">
          <div className="page-header">
            <h4>Asset Images</h4>
          </div>
          <hr/>
            <div className="row">
              {this.renderPhoto()}
            </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/asset/photo/helper/component/PhotoList.js